module.exports = __webpack_public_path__ + "img/introduce1.d5da2889.png";